/**
 * Scroll to top button functionality
 *
 * @author Matt Haynes <mattgh9152@gmail.com>
 * @package Boohooman - Tracksuit testers
 */

const scrollToTop = () => {
    const button = document.getElementById('scrollTop');
    if (!button) return;

    window.addEventListener('scroll', () => {
        const scrollPos = window.scrollY;

        if (scrollPos > 100) {
            button.classList.add('visible');
        } else {
            button.classList.remove('visible');
        }
    });

    const options = {
        top: 0,
        left: 0,
        behavior: 'smooth',
    };

    button.addEventListener('click', () => {
        window.scroll(options);
    });
};

export default scrollToTop;
